//TIMEPASS - USA AND CAD
export const TIMEPASSCOUNTRY = ['USD', 'CAD'];
export const TIMEPASSCODE = [
  {name:'Unlimted pass', tourID:'EIA'},
  {name:'Stop pass', tourID:'EJ2'},
  {name:'Timed pass', tourID:'ET4'}
];


//COUNTRIES
export const COUNTRIES = [
    {country:"GBP", currency:"£"},
    {country:"AUD", currency:"$"},
    {country:"NZD", currency:"$"},
    {country:"USD", currency:"$"},
    {country:"CAD", currency:"$"},
    {country:"ZAR", currency:"R"},
    {country:"EUR", currency:"€"}
];


//CURRENCY FALLBACK
export const CURRENCY_FALLBACK = {iso_currency_code: "USD", currency: "Dollar", currency_mask: "$#,##0.00 "};


//SLACK WEBHOOK
export const SLACK_WEBHOOKS = {
  errors:"https://hooks.slack.com/services/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",
  confirmation:"https://hooks.slack.com/services/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"
}


export const LOCAL_STORAGE_CONFIG = { key:"BusaboutBuilder" };

export const APP_CONTAINER_ID = "root";

//CREATE YOUR OWN ADVENTURE
export const CYOA_NETWORK_IDS = {
  "europe":{ id:"CYO", name:"europe", slug: (process.env.NODE_ENV  === "production") ? `/trips${process.env.REACT_APP_DISCOVER_EUROPE_PAGE}` : process.env.REACT_APP_DISCOVER_EUROPE_PAGE },
  "usa": { id: "CYU", name:"usa", slug: (process.env.NODE_ENV === "production") ? `/trips${process.env.REACT_APP_DISCOVER_USA_PAGE}` : process.env.REACT_APP_DISCOVER_USA_PAGE }
}




//COUNTRY PHONE NUMBERS
export const PHONE_NUMBERS = {
  USDCAD: ["+18776684328", "+1 877 668 4328"],
  GBPEUR: ["08082811114", "0808 281 1114"],
  AUD:["1300287226", "1300 287 226"],
  NZD:["0508287226", "0508 287 226"]
}


//POPULAR COUNTRIES LIST
export const POPULAR_COUNTRIES = [
  "Australia", "US", "Canada", "UK", "New Zealand", "South Africa", "Germany", "France", "Poland", "Portugal"
]

//FUSE FUZZY OPTIONS
export const FUSE_OPTIONS = {
  shouldSort: true,
  tokenize: true,
  threshold: 0.3,
  location: 1,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 3,
  keys: ["name", "dialing_code"]
}


//LOCKOUT MESSAGES
export const LOCKOUT_MESSAGES = {
  passengerDetailsTitle:'Last minute Booking Request',
  passengerDetailsText:'This tour is departing soon, therefore <a href="https://www.busabout.com/terms-conditions/last-minute-bookings" target="_blank" class="busabout--cta--link orange">Special Conditions Apply</a>. You can continue the booking process, but the booking will have to be confirmed by our sales agents once received. The amount to be paid will be pre-authorised on your card, but the funds will be taken from your account once our sales agent confirms availability of this product with you. <b>Please provide a correct telephone number below.</b>',
  bookingSummaryMeta:'<span class="hide-for-small-only"> |</span><span class="orange-text"> *</span> Special <a href="https://www.busabout.com/terms-conditions/last-minute-bookings" target="_blank" class="busabout--cta--link orange">Terms &amp; Conditions</a> apply to this booking'
}



//SLICK SLIDERS SETTINGS
export const IMAGE_SLICK_SETTINGS = {
  dots: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 2000,
  cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)'
}


// WEBPACK FOOTER //
// ./src/config.js